import { createSlice } from "@reduxjs/toolkit";
import * as actions from "./action";
import {  ScheduleType } from "./types";

type initialState = {
  scheduleList: ScheduleType[];
  isLoading: boolean;
};
const scheduleSlice = createSlice({
  name: "Schedule",
  initialState: {
    scheduleList: [],
    isLoading: false,
  } as initialState,
  reducers: {},
  extraReducers(builder) {
    builder      
      .addCase(actions.getScheduleCalenderList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.scheduleList = action.payload;
      })
      .addCase(actions.getScheduleCalenderList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(actions.getScheduleCalenderList.rejected, (state) => {
        state.isLoading = false;
        state.scheduleList = [];
      })
  },
});

export const {} = scheduleSlice.actions;
export default scheduleSlice.reducer;
